import { withAlpha } from "@/lib/color";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const UPGRADE_LABEL = {
    foundation: { label: "Fondazione", desc: "Liv.1 → 10k posti + 10 Ugly", color: "rgb(var(--tc-e8ff00))" },
    stadium_2: { label: "Ampliamento", desc: "Liv.2a → 15k posti", color: "rgb(var(--tc-2bb6ff))" },
    ugly_2: { label: "Estensione Ugly", desc: "Liv.2b → 15 Ugly", color: "rgb(var(--tc-ff7a1a))" },
    stadium_3: { label: "Maxi Ampliamento", desc: "Liv.3a → 20k posti", color: "rgb(var(--tc-2bb6ff))" },
    ugly_3: { label: "Estensione Ugly+", desc: "Liv.3b → 17 Ugly", color: "rgb(var(--tc-ff7a1a))" },
};

export default function AdminStadi() {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(null);
    const [err, setErr] = useState(null);
    const [filter, setFilter] = useState("");
    const [editing, setEditing] = useState(null); // {teamId, stadium, ugly}
    const [backfill, setBackfill] = useState(null);
    const [reconcile, setReconcile] = useState(null);

    const reload = () => {
        api.get("/admin/stadiums").then((r) => setData(r.data)).catch((e) => setErr(e.message));
    };
    useEffect(reload, []);

    const upgrade = async (teamId, upg) => {
        const cost = data.costs[upg];
        if (!window.confirm(`Confermi ${UPGRADE_LABEL[upg].label}?\n\nCosto: ${(cost.price / 1e6).toFixed(0)} mln EUR\nDal budget squadra al Tesoro OP.`)) return;
        setBusy(`${teamId}:${upg}`);
        setErr(null);
        try {
            await api.post(`/admin/teams/${teamId}/stadium/upgrade`, { upgrade: upg });
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setBusy(null);
        }
    };

    const removeUpgrade = async (teamId, upg) => {
        if (!window.confirm(
            `Rimuovere "${UPGRADE_LABEL[upg].label}"?\n\nLa capienza torna al livello precedente.\nNessun movimento di cassa (budget e Tesoro invariati).`
        )) return;
        setBusy(`${teamId}:rm:${upg}`);
        setErr(null);
        try {
            await api.post(`/admin/teams/${teamId}/stadium/downgrade`, { upgrade: upg });
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setBusy(null);
        }
    };

    const runBackfill = async () => {
        if (!window.confirm("Segnare 'sviluppo club usato' per tutte le squadre che hanno già acquistato nella finestra estiva aperta?\n\nBloccherà ulteriori acquisti da presidente per la stagione corrente.")) return;
        setBusy("backfill"); setErr(null); setBackfill(null);
        try {
            const { data: r } = await api.post("/admin/club-dev/backfill-current-window");
            setBackfill(r);
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally { setBusy(null); }
    };

    const toggleClubDev = async (teamId, currentUsed) => {
        setBusy(`cd:${teamId}`); setErr(null);
        try {
            await api.post(`/admin/teams/${teamId}/club-dev-season`, { used: !currentUsed });
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally { setBusy(null); }
    };


    const runReconcile = async () => {
        if (!window.confirm("Sincronizzare le capienze numeriche con i livelli realmente posseduti?\n\nUtile per gli stadi costruiti dal Tesoro il cui header mostrava ancora la capienza vecchia.\nIdempotente: alza solo, non abbassa mai.")) return;
        setBusy("reconcile"); setErr(null); setReconcile(null);
        try {
            const { data: r } = await api.post("/admin/stadiums/reconcile-capacity");
            setReconcile(r);
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally { setBusy(null); }
    };

    const saveEdit = async () => {
        setBusy(`edit:${editing.teamId}`);
        setErr(null);
        try {
            await api.put(`/admin/teams/${editing.teamId}/stadium`, {
                stadium_capacity: Number(editing.stadium),
                ugly_capacity: Number(editing.ugly),
            });
            setEditing(null);
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setBusy(null);
        }
    };

    if (!data) return <div className="op-mono text-sm text-t8f95a3 animate-pulse">// CARICAMENTO…</div>;

    const teams = data.teams.filter((t) => !filter || t.name.toLowerCase().includes(filter.toLowerCase()));

    return (
        <div data-testid="admin-stadi-page">
            <div className="op-label" style={{ color: "rgb(var(--tc-e8ff00))" }}>// STADI & SETTORE UGLY</div>
            <h2 className="op-heading text-3xl mt-2 mb-2">Gestione Stadi</h2>
            <p className="op-mono text-xs text-t8f95a3 mb-4 max-w-3xl leading-relaxed">
                Tabella editabile di stadi e settori Ugly. Usa i bottoni <span className="text-te8ff00">+ Aggiungi</span> per
                applicare gli upgrade del regolamento (art. 10): la cifra viene scalata dal budget squadra e versata al Tesoro OP.
                I bottoni <span className="text-tff6b6b">− Rimuovi</span> tolgono un livello già posseduto (solo l'ultimo di ogni ramo): la capienza
                torna al livello precedente <strong className="text-tff6b6b">senza alcun movimento di cassa</strong>.
                L'icona <span className="text-tff7a1a">✎</span> apre la modifica manuale dei numeri (override, senza movimenti di cassa).
            </p>

            {/* Sviluppo club — limite 1/stagione */}
            <div className="op-card p-4 mb-4" data-testid="club-dev-backfill-card">
                <div className="op-label mb-1" style={{ color: "rgb(var(--tc-ff9d2b))" }}>// SVILUPPO CLUB · LIMITE 1/STAGIONE</div>
                <p className="op-mono text-[11px] text-t8f95a3 leading-relaxed mb-3 max-w-3xl">
                    Ogni squadra può fare <strong className="text-tffffff">1 solo</strong> acquisto di sviluppo club (ampliamento stadio O struttura Liv.4)
                    a stagione dai pulsanti da presidente. Se un club ha già acquistato <em>prima</em> di questo aggiornamento,
                    segna qui gli acquisti della finestra estiva aperta per bloccare il secondo (una-tantum, idempotente).
                    Stagione corrente: <strong className="text-tffffff">{data.current_season ?? "—"}</strong>.
                </p>
                <button
                    onClick={runBackfill}
                    disabled={busy === "backfill"}
                    className="op-mono text-[11px] uppercase tracking-wider px-3 py-2 border transition-colors disabled:opacity-40"
                    style={{ borderColor: "rgb(var(--tc-ff9d2b))", color: "rgb(var(--tc-ff9d2b))" }}
                    data-testid="club-dev-backfill-btn"
                >
                    {busy === "backfill" ? "..." : "Segna sviluppo club già usato (finestra estiva aperta)"}
                </button>
                {backfill && (
                    <div className="op-mono text-[11px] mt-3 border border-t22252a p-2.5" data-testid="club-dev-backfill-result">
                        {backfill.window_open === false ? (
                            <span className="text-tff6b6b">{backfill.message}</span>
                        ) : (
                            <span className="text-t2ecc71">
                                Segnate {backfill.count} squadre (stagione {backfill.season}, finestra «{backfill.window_name}»):{" "}
                                {backfill.teams.map((x) => x.name).join(", ") || "nessuna"}.
                            </span>
                        )}
                    </div>
                )}
            </div>

            {/* Sincronizza capienze con i livelli posseduti */}
            <div className="op-card p-4 mb-4" data-testid="reconcile-capacity-card">
                <div className="op-label mb-1" style={{ color: "rgb(var(--tc-2bb6ff))" }}>// SINCRONIZZA CAPIENZE STADIO</div>
                <p className="op-mono text-[11px] text-t8f95a3 leading-relaxed mb-3 max-w-3xl">
                    Allinea la <strong className="text-tffffff">capienza numerica</strong> (mostrata nell'header squadra) ai livelli
                    realmente posseduti. Serve per gli stadi costruiti tramite il modale <em>Tesoro → «Costruzione stadio»</em>,
                    dove la capienza poteva restare al valore precedente. Operazione <strong className="text-tffffff">idempotente</strong>:
                    alza solo le capienze, non le abbassa mai.
                </p>
                <button
                    onClick={runReconcile}
                    disabled={busy === "reconcile"}
                    className="op-mono text-[11px] uppercase tracking-wider px-3 py-2 border transition-colors disabled:opacity-40"
                    style={{ borderColor: "rgb(var(--tc-2bb6ff))", color: "rgb(var(--tc-2bb6ff))" }}
                    data-testid="reconcile-capacity-btn"
                >
                    {busy === "reconcile" ? "..." : "Sincronizza capienze con i livelli posseduti"}
                </button>
                {reconcile && (
                    <div className="op-mono text-[11px] mt-3 border border-t22252a p-2.5" data-testid="reconcile-capacity-result">
                        {reconcile.count === 0 ? (
                            <span className="text-t2ecc71">Tutte le capienze sono già allineate. Nessuna modifica.</span>
                        ) : (
                            <span className="text-t2ecc71">
                                Aggiornate {reconcile.count} squadre:{" "}
                                {reconcile.teams.map((x) => `${x.name} (${x.from.stadium.toLocaleString("it-IT")}→${x.to.stadium.toLocaleString("it-IT")})`).join(", ")}.
                            </span>
                        )}
                    </div>
                )}
            </div>

            {/* Costs recap */}
            <div className="op-card p-4 mb-4">
                <div className="op-label mb-2 text-t8f95a3">// COSTI UPGRADE</div>
                <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-2">
                    {Object.entries(data.costs).map(([k, c]) => (
                        <div key={k} className="border border-t22252a p-2.5 text-[11px]">
                            <div className="op-mono uppercase" style={{ color: UPGRADE_LABEL[k]?.color }}>
                                {UPGRADE_LABEL[k]?.label || k}
                            </div>
                            <div className="op-mono text-[10px] text-t8f95a3">{UPGRADE_LABEL[k]?.desc}</div>
                            <div className="op-heading text-base text-tffffff mt-1">{(c.price / 1e6).toFixed(0)} mln</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Filter */}
            <input
                placeholder="Cerca squadra…"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="op-input w-full sm:w-80 mb-3"
                data-testid="stadi-filter"
            />

            {err && (
                <div className="border border-tff3b30 bg-tff3b30/10 text-tff3b30 text-xs p-2 mb-3" data-testid="stadi-err">
                    {err}
                </div>
            )}

            {/* Table */}
            <div className="op-card overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="text-[10px] uppercase tracking-wider text-t8f95a3 border-b border-t22252a">
                        <tr>
                            <th className="py-2 px-3 text-left">Squadra</th>
                            <th className="py-2 px-3 text-right">Budget</th>
                            <th className="py-2 px-3 text-center">Stadio</th>
                            <th className="py-2 px-3 text-center">Ugly</th>
                            <th className="py-2 px-3 text-center">Sviluppo</th>
                            <th className="py-2 px-3 text-right">Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teams.map((t) => {
                            const isEditing = editing?.teamId === t.id;
                            return (
                                <tr key={t.id} className="border-b border-t1a1d24 hover:bg-t0f1115" data-testid={`row-${t.id}`}>
                                    <td className="py-2 px-3 text-tffffff">{t.name}</td>
                                    <td className="py-2 px-3 text-right op-mono text-t8f95a3">{(t.budget / 1e6).toFixed(0)}M</td>
                                    <td className="py-2 px-3 text-center op-mono">
                                        {isEditing ? (
                                            <input
                                                type="number"
                                                value={editing.stadium}
                                                onChange={(e) => setEditing({ ...editing, stadium: e.target.value })}
                                                className="op-input w-24 text-center"
                                            />
                                        ) : (
                                            <span style={{ color: t.stadium_capacity ? "rgb(var(--tc-e8ff00))" : "rgb(var(--tc-5c6370))" }}>
                                                {t.stadium_capacity.toLocaleString("it-IT")}
                                            </span>
                                        )}
                                    </td>
                                    <td className="py-2 px-3 text-center op-mono">
                                        {isEditing ? (
                                            <input
                                                type="number"
                                                value={editing.ugly}
                                                onChange={(e) => setEditing({ ...editing, ugly: e.target.value })}
                                                className="op-input w-16 text-center"
                                            />
                                        ) : (
                                            <span style={{ color: t.ugly_capacity > 5 ? "rgb(var(--tc-ff7a1a))" : "rgb(var(--tc-5c6370))" }}>
                                                {t.ugly_capacity}
                                            </span>
                                        )}
                                    </td>
                                    <td className="py-2 px-3 text-center op-mono">
                                        <button
                                            onClick={() => toggleClubDev(t.id, t.club_dev_used)}
                                            disabled={busy === `cd:${t.id}`}
                                            className="op-mono text-[10px] uppercase tracking-wider px-2 py-1 border transition-colors disabled:opacity-40"
                                            style={t.club_dev_used
                                                ? { borderColor: "rgb(var(--tc-ff9d2b))", color: "rgb(var(--tc-ff9d2b))", backgroundColor: "rgb(var(--tc-ff9d2b) / 0.078)" }
                                                : { borderColor: "rgb(var(--tc-22252a))", color: "rgb(var(--tc-5c6370))" }}
                                            title={t.club_dev_used ? "Usato questa stagione — click per riabilitare" : "Disponibile — click per segnare come usato"}
                                            data-testid={`club-dev-toggle-${t.id}`}
                                        >
                                            {busy === `cd:${t.id}` ? "..." : t.club_dev_used ? "● Usato" : "○ Libero"}
                                        </button>
                                    </td>
                                    <td className="py-2 px-3 text-right">
                                        {isEditing ? (
                                            <div className="flex justify-end gap-1">
                                                <button
                                                    onClick={() => setEditing(null)}
                                                    className="op-mono text-[10px] px-2 py-1 border border-t22252a text-t8f95a3"
                                                    data-testid={`cancel-${t.id}`}
                                                >
                                                    ✕
                                                </button>
                                                <button
                                                    onClick={saveEdit}
                                                    disabled={busy === `edit:${t.id}`}
                                                    className="op-mono text-[10px] px-2 py-1 border border-t2bb6ff text-t2bb6ff"
                                                    data-testid={`save-${t.id}`}
                                                >
                                                    {busy === `edit:${t.id}` ? "..." : "Salva"}
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flex justify-end gap-1 flex-wrap">
                                                {t.removable_upgrades?.map((u) => (
                                                    <button
                                                        key={`rm-${u}`}
                                                        onClick={() => removeUpgrade(t.id, u)}
                                                        disabled={busy === `${t.id}:rm:${u}`}
                                                        className="op-mono text-[10px] uppercase tracking-wider px-2 py-1 border transition-colors disabled:opacity-40"
                                                        style={{ borderColor: "rgb(var(--tc-ff3b30) / 0.333)", color: "rgb(var(--tc-ff6b6b))" }}
                                                        title={`Rimuovi ${UPGRADE_LABEL[u].label} — torna al livello precedente (nessuna cassa)`}
                                                        data-testid={`rm-${t.id}-${u}`}
                                                    >
                                                        {busy === `${t.id}:rm:${u}` ? "..." : `− ${UPGRADE_LABEL[u].label}`}
                                                    </button>
                                                ))}
                                                {t.available_upgrades.map((u) => {
                                                    const c = data.costs[u];
                                                    const cantAfford = t.budget < c.price;
                                                    return (
                                                        <button
                                                            key={u}
                                                            onClick={() => upgrade(t.id, u)}
                                                            disabled={busy === `${t.id}:${u}` || cantAfford}
                                                            className="op-mono text-[10px] uppercase tracking-wider px-2 py-1 border transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                                                            style={{
                                                                borderColor: withAlpha(UPGRADE_LABEL[u].color, "55"),
                                                                color: UPGRADE_LABEL[u].color,
                                                            }}
                                                            title={`${UPGRADE_LABEL[u].label} · ${(c.price / 1e6).toFixed(0)}mln${cantAfford ? " (budget insufficiente)" : ""}`}
                                                            data-testid={`upg-${t.id}-${u}`}
                                                        >
                                                            {busy === `${t.id}:${u}` ? "..." : `+ ${UPGRADE_LABEL[u].label}`}
                                                        </button>
                                                    );
                                                })}
                                                <button
                                                    onClick={() => setEditing({ teamId: t.id, stadium: t.stadium_capacity, ugly: t.ugly_capacity })}
                                                    className="op-mono text-[10px] px-2 py-1 border border-t22252a hover:border-tff7a1a text-tff7a1a"
                                                    title="Modifica manuale (override, no cassa)"
                                                    data-testid={`edit-${t.id}`}
                                                >
                                                    ✎
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="op-mono text-[10px] text-t5c6370 leading-relaxed mt-4">
                ⚠ I bottoni "+" applicano gli upgrade del <a href="/regolamento" className="text-t2bb6ff hover:underline">regolamento art. 10</a>:
                la cifra esce dal budget squadra ed entra nel Tesoro OP (registrato come <code>stadium_build</code>).
                Le modifiche manuali (✎) servono per allineamenti dati e <strong className="text-tff7a1a">non muovono cassa</strong>.
            </div>
        </div>
    );
}
